import React from 'react'
import { Link } from 'gatsby'
import Image from '../components/Image'

const FeaturedContent = ( props ) => (
		<div className={ props.cssClass } style={{ backgroundColor: props.cssClass }}>
			<div className="container">
				<div className="featured-content__image">
					<div className="featured-content__image-inner">
						<Image filename={props.imageSrc} alt={props.imageAlt} />
					</div>
				</div>
				<div className="featured-content__text">
					<div className="text">
						<h2 className="heading">{ props.heading }</h2>
						{props.children}
					</div>
					<Link
						to={ props.btnAction }
						className="btn btn--primary btn--red">
						{ props.btnLabel }
					</Link>
				</div>
			</div>
		</div>
)

export default FeaturedContent